
const colunsProviderNotifications = [
    {
        uniqid: 'notification_title',
        label: 'TÍTULO',
        field: 'title',
        visible: true,
        sortable: true,
        sortOrder: 'asc',
        classes: 'border-b text-sm',
        headerClass: 'p-4 text-left',
        // format: (val, row) => row.sales_promoter_label ? row.sales_promoter_label : ''
    },

    {
        uniqid: 'notification',
        label: 'NOTIFICAÇÃO',
        field: 'text',
        visible: true,
        sortable: true,
        sortOrder: 'asc',
        classes: 'border-b text-sm',
        headerClass: 'p-4 text-left',
        // format: (val, row) => row.sales_promoter_label ? row.sales_promoter_label : ''
    },

    {
        uniqid: 'send_date',
        label: 'DATA DE ENVIO',
        field: 'date',
        visible: true,
        sortable: true,
        sortOrder: 'asc',
        classes: 'border-b text-sm',
        headerClass: 'p-4 text-left',
        // format: (val, row) => row.sales_promoter_label ? row.sales_promoter_label : ''
    },

    {
        uniqid: 'actions',
        label: 'Ações',
        field: 'id',
        visible: true,
        align: 'center',
        classes: 'py-3 border-b',
        headerClass: 'p-4',
    },
];


export { colunsProviderNotifications }